export default "__VITE_ASSET__DGs4UNEp__"